import configs from '@/config'

// Sentry
import Vue from 'vue'
import * as Sentry from '@sentry/vue'
import { Integrations } from '@sentry/tracing'

const ignoreErrors = [
  'zaloJSV2 is not defined',
  'Can\'t find variable: zaloJSV2',
  'ResizeObserver loop limit exceeded',
  'Cannot read property \'getReadModeConfig\' of undefined',
  'Cannot read property \'getReadModeRender\' of undefined',
  'Cannot read property \'getReadModeExtract\' of undefined',
  'UnhandledRejection: Non-Error promise rejection captured with value: Object Not Found Matching Id:2',
]

const init = () => {
  if (!configs.isSentryEnabled) return

  Sentry.init({
    release: configs.sentryRelease,
    dsn: configs.sentry,
    environment: configs.env,
    integrations: [new Integrations.BrowserTracing()],
    tracesSampleRate: 0,
    Vue,
    ignoreErrors,
    tracingOptions: {
      trackComponents: true,
    },
  })
}

const captureException = (message, options) => {
  if (!configs.isSentryEnabled) return

  try {
    Sentry.captureException(new Error(message), options)
  } catch {
    // do nothing
  }
}

const addBreadcrumb = (breadcrumb = {}) => {
  if (!configs.isSentryEnabled) return

  try {
    const editedBreadcrumb = { ...breadcrumb }

    if (breadcrumb.level === 'info') {
      editedBreadcrumb.level = Sentry.Severity.Info
    }

    Sentry.addBreadcrumb(editedBreadcrumb)
  } catch {
    // do nothing
  }
}

export default {
  init,
  captureException,
  addBreadcrumb,
}
